import { HeaderUtilities } from "@/components/ui";

/**
 * Default sidebar-page header: the same sticky `xl:`-and-up chrome as
 * MarketplaceUtilityHeader (marketplace + PDP), minus that variant's
 * search/Upload/cart controls — just notifications + avatar.
 */
export function AppHeader() {
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-20 hidden h-16 items-center justify-end gap-2 bg-bg/55 px-6 backdrop-blur-lg xl:flex lg:px-8"
    >
      <HeaderUtilities />
    </header>
  );
}
